<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn x-small fab color="accent" :disabled="disabled" @click="buttonLink" v-on="on"><v-icon>{{icon}}</v-icon></v-btn>
    </template>
    <span>Lead</span>
  </v-tooltip>
</template>

<script>
  import { mdiAccountDetails } from '@mdi/js';
  export default {
    props: {
      leadid: {
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        icon: mdiAccountDetails
      }
    },
    methods: {
      buttonLink() {
        this.$router.push(`/leads/${this.leadid}/`);
      }
    },
  }
</script>
